import script from "./online-black-and-white-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./online-black-and-white-list.vue?vue&type=script&setup=true&lang=ts"

import "./online-black-and-white-list.vue?vue&type=style&index=0&id=549c5a92&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-549c5a92"]])

export default __exports__